import React, { memo } from 'react';

const MainInner = () => (
    <svg viewBox="0 0 18 19">
        <path d="M9.32704 0L8.8043 0.367188L0.815411 5.96289V17C0.815411 18.0931 1.67313 19 2.70688 19H15.9472C16.9809 19 17.8387 18.0931 17.8387 17V5.96289L9.32704 0ZM9.32704 2.39844L15.9472 7.03711V17H2.70688V7.03711L9.32704 2.39844Z" />
    </svg>
);

export const Main = memo(MainInner);
